export const faqItems = [
  {
    id: "faq001",
    question: "妖精视频需要付费吗？",
    answer: "妖精视频提供大量免费高清内容，用户无需付费即可观看海量影视资源。部分独家内容和最新剧集可能仅对付费会员开放，但我们始终保证有充足的免费内容供您畅享。",
  },
  {
    id: "faq002",
    question: "观看视频时为什么会出现缓冲？",
    answer: "视频缓冲可能与您的网络环境有关。建议您检查网络连接速度（推荐4Mbps以上），关闭其他占用带宽的应用，或选择较低的清晰度播放。我们的服务器采用CDN加速技术，正常情况下可以保证流畅播放。",
  },
  {
    id: "faq003",
    question: "支持哪些设备观看？",
    answer: "妖精视频支持全平台观看，包括PC电脑、平板电脑、iOS和Android手机。您可以在任何设备上通过浏览器访问我们的网站，无需下载额外的APP即可享受高清观影体验。",
  },
  {
    id: "faq004",
    question: "视频支持哪些清晰度？",
    answer: "我们提供从480P到4K的多种清晰度选择。系统会根据您的网络状况自动推荐最佳清晰度，您也可以手动切换。大部分热门内容均支持1080P及以上高清画质。",
  },
  {
    id: "faq005",
    question: "如何查找我想看的视频？",
    answer: "您可以通过网站顶部的搜索栏输入视频名称进行搜索，也可以通过分类浏览找到感兴趣的内容。我们还提供了热门推荐、最新上架等栏目，帮助您发现精彩内容。",
  },
  {
    id: "faq006",
    question: "视频更新频率如何？",
    answer: "我们会持续追踪各大平台的最新内容，热门剧集通常在播出后24小时内更新。电影、综艺等内容的更新速度也保持在行业领先水平，确保您不会错过任何精彩。",
  },
  {
    id: "faq007",
    question: "妖精视频是否安全合法？",
    answer: "妖精视频水果植物系列是一个内容聚合平台，致力于为用户提供便捷的观影导航服务。我们严格遵守相关法律法规，建议用户通过正版渠道观看视频内容，支持正版影视作品。",
  },
  {
    id: "faq008",
    question: "如何联系我们？",
    answer: "您可以通过网站的「关于我们」页面找到联系方式，包括电子邮箱和在线客服。我们会在工作时间内尽快回复您的咨询和建议。",
  },
];